import React, { Fragment } from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { appendChildGroupFunctions } from '../../../../../shared/appendChildGroupFunctions.js';
import { InjectedStyledComponent } from '../../../../../shared/index.js';
import { ITableEvents } from '../../models/index.js';
import { ITableGroup } from '../../models/ITableGroup.js';
import { ITableRow } from '../../models/ITableRow.js';
import Row from '../Row/Row.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { IChildRowsConfiguration, IChildRowsProps, IChildRowsState } from './models/index.js';
import {
	CHILD_ROWS_CATEGORY_KEY,
	CHILD_ROWS_COMPONENT_KEY,
	CHILD_ROWS_PARENT_COMPONENT_KEY,
} from './ChildRows.meta.js';

export class ChildRows extends TableComponentBase<IChildRowsProps, IChildRowsState, IChildRowsConfiguration> {
	categoryKey = CHILD_ROWS_CATEGORY_KEY;
	componentKey = CHILD_ROWS_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return CHILD_ROWS_PARENT_COMPONENT_KEY;
	}

	get tableEventsKey(): keyof ITableEvents | undefined {
		return undefined;
	}

	constructor(props: IChildRowsProps) {
		super(props);

		makeObservable(this, {
			rows: computed,
			grouping: computed,
		});
	}

	get rows(): ITableRow[] | undefined {
		return this.props.rows || [];
	}

	get grouping(): ITableGroup | undefined {
		return this.props.grouping;
	}

	get childGrouping(): ITableGroup | undefined {
		if (this.grouping) {
			const childGroup = appendChildGroupFunctions(this.grouping);
			return childGroup ? childGroup : undefined;
		}
		return undefined;
	}

	render() {
		return (
			<Fragment>
				{this.rows &&
					this.rows.length > 0 &&
					this.rows.map((row, rowIndex) => {
						const key = this.getRowKey(row, rowIndex);
						const rowStyleProps = this.getRowStyleProps(row, rowIndex, this.childGrouping);
						return (
							<Row
								{...rowStyleProps}
								key={key}
								table={this.table}
								row={row}
								rowIndex={rowIndex}
								grouping={this.childGrouping}
							/>
						);
					})}
			</Fragment>
		);
	}
}

export default InjectedStyledComponent(observer(ChildRows), CHILD_ROWS_CATEGORY_KEY, CHILD_ROWS_PARENT_COMPONENT_KEY, [
	CHILD_ROWS_COMPONENT_KEY,
]);
